var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('purposesCloudResume'),_c('usersRecognitionsResume'),_c('purposesCloudHistory'),_c('exportRecognitionsReport'),_c('exportReportFull')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }